import { render, staticRenderFns } from "./SetLevel.vue?vue&type=template&id=45a009c4&scoped=true"
import script from "./SetLevel.vue?vue&type=script&lang=js"
export * from "./SetLevel.vue?vue&type=script&lang=js"
import style0 from "./SetLevel.vue?vue&type=style&index=0&id=45a009c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a009c4",
  null
  
)

export default component.exports